export interface SpecialItem {
  id: string;
  title: string;
  cover: string;
  intro: string;
  reason: string;
  videoIds: string[];
}

export const specials: SpecialItem[] = [
  {
    id: "city-walk",
    title: "城市漫游计划",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20city%20street%20scene%20at%20golden%20hour%2C%20old%20buildings%20and%20morning%20market%20stalls%2C%20long%20soft%20shadows%2C%20cozy%20urban%20documentary%20aesthetic%2C%20warm%20orange%20tones%2C%20realistic%20photography%2C%20high%20detail&width=1200&height=600&seq=special-city&orientation=landscape",
    intro:
      "不必远行，城市的每个角落都值得被慢慢走过。这个专题收集了菜市场、老街、清晨通勤路上的真实片段，带你重新认识我们每天生活的地方。",
    reason: "适合周末不想出门时的下饭视频，越看越有生活感。",
    videoIds: ["v1", "v2", "v4", "v5", "v6", "v8"],
  },
  {
    id: "solo-life",
    title: "一个人的生活美学",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20solo%20living%20scene%20with%20warm%20lamp%2C%20a%20book%20and%20tea%20on%20a%20small%20table%2C%20soft%20evening%20light%2C%20peaceful%20minimal%20interior%2C%20warm%20neutral%20palette%2C%20realistic%20photography%2C%20high%20detail&width=1200&height=600&seq=special-solo&orientation=landscape",
    intro:
      "独居不等于将就。这个专题讲一个人怎么好好吃饭、好好生活、好好和自己相处，献给每一个在大城市里独自生活的你。",
    reason: "治愈又真诚，很多人看完说像在和自己对话。",
    videoIds: ["v3", "v7", "v15", "v17", "v20", "v21"],
  },
  {
    id: "mountain-sea",
    title: "山海之间",
    cover:
      "https://readdy.ai/api/search-image?query=Sweeping%20coastal%20mountains%20meeting%20the%20sea%20at%20sunset%2C%20warm%20golden%20sky%20reflecting%20on%20water%2C%20epic%20nature%20travel%20landscape%2C%20warm%20tones%2C%20realistic%20cinematic%20photography%2C%20high%20detail&width=1200&height=600&seq=special-sea&orientation=landscape",
    intro:
      "从海岛到沙漠，从云海到渔村，收录了这几趟旅行的完整记录。如果你也想出发，这个专题会告诉你路上的真实样子。",
    reason: "风景顶配，最适合周末躺着看，看着看着就想订票。",
    videoIds: ["v9", "v10", "v12", "v13", "v14", "v16"],
  },
];